import { BASE_LOCALE, useLocale } from "@outschool/localization";

const EnglishOnly = ({ children }: { children: any }) => {
  const isEnglishPage: boolean = useLocale() === BASE_LOCALE;
  return isEnglishPage && children;
};

export default EnglishOnly;
